export const alternativeIdFieldName = (field: string, id: number) => `alternativeId_${field}_${id}`;
